import * as React from "react";
interface SVGProps {
  height?: number | string;
  width?: number | string;
  color?: string;
}

const SvgArrowRightMono = (props: SVGProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      {...props}
    >
      <path
        d="M6.768 6.616L5.952 5.8L7.36 4.392L8.16 3.944L8.08 3.752L7.36 3.976H0.576V2.824H7.36L8.08 3.048L8.16 2.856L7.36 2.408L5.952 1L6.768 0.184L9.216 2.632V4.168L6.768 6.616Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default SvgArrowRightMono;
